<div #container class="media-collection" >
  <img class="media-image" [src]="selectedImage?.url">
</div>

<!--overlay con la controladora de la galeria-->
<app-collection-controller [collection]="collection" (indexSelected)="collectionIndexOnChanged($event)" ></app-collection-controller>
